import { useState } from 'react';

import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { apiService } from '@/lib/axios';

const ReactivateUserModal = ({ open, onOpenChange, user, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleClose = (isOpen) => {
    if (!isOpen) {
      setLoading(false);
      setError(null);
    }
    onOpenChange(isOpen);
  };

  const handleConfirm = async () => {
    setLoading(true);
    setError(null);

    try {
      await apiService.users.enableUser(user.id);
      if (onSuccess) onSuccess();
      handleClose(false);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to reactivate user');
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Reactivate User</DialogTitle>
          <DialogDescription>
            Are you sure you want to reactivate{' '}
            <span className="font-medium">{user?.email}</span>? They will be
            able to log in again.
          </DialogDescription>
        </DialogHeader>

        {error && <p className="text-sm text-red-500">{error}</p>}

        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => handleClose(false)}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button onClick={handleConfirm} disabled={loading}>
            {loading ? 'Reactivating...' : 'Reactivate'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ReactivateUserModal;
